import React from 'react';

export function mcBleach() {
	return (
		<div>
			<h2>BLEACH + VINEGAR = CHLORINE GAS</h2>
			<p className="weaponsText">
				Toxic yellow-green gas. Can cause permanent lung damage or death, if
				inhaled long enough.
			</p>
			<br />
			<h2>BLEACH + AMMONIA = CHLORAMINE VAPORS</h2>
			<p className="weaponsText">Less toxic than chlorine gas, colorless.</p>
			<br />
			<h2>BLEACH + RUBBING ALCOHOL = CHLOROFORM</h2>
			<p className="weaponsText">
				Solvent and anesthetic. Can render someone unconscious if breathed
				through a rag for <i>at least</i> five minutes. Can kill someone if used
				longer.
			</p>
		</div>
	);
}
export function mcHydrogenPeroxide() {
	return (
		<div>
			<h2>HYDROGEN PEROXIDE + VINEGAR = PARACETIC ACID</h2>
			<p className="weaponsText">
				Industrial disinfectant. Can cause permanent damage of the lungs and
				skin, as well as blindness.
			</p>
		</div>
	);
}

export function mcWaspSpray() {
	return (
		<div>
			<h2>WASP SPRAY = LEGAL PEPPER SPRAY ALTERNATIVE</h2>
			<p className="weaponsText">
				Some jurisdictions make it a criminal offence to carry pepperspray. Wasp
				spray can be just as effective in thwarting an attacker. Some
				formulations can cause blindness.
			</p>
		</div>
	);
}
export function mcGas() {
	return (
		<div>
			<h2>GASOLINE + FIRE = MOLOTOV COCKTAIL</h2>
			<p className="weaponsText">
				Typically made by:
				<ul>
					<li>
						Stuffing a dry rag deep into breakable container, leaving some
						hanging out, as a wick.
					</li>
					<li>
						Stuffing a funnel into the neck of the bottle alongside the wick.
					</li>
					<li>
						Pouring gasoline (or kerosene, or rubbing alcohol, or a 100+ proof
						liquor) into the bottle whilst soaking the portion of the rag that
						is inside the bottle, until the volume of the liquid matches the
						size of the desired fireball.
					</li>
					<li>
						Soaking the rest of the rag, that is hanging outside the bottle,
						with fuel.
					</li>
				</ul>
				Must be thrown against a hard object in order for it to break. Throwing
				at an arc and at a distance can help insure the bottle breaks. Will not
				work if you stuff the rag into a bottle after it's been filled. The rag
				will float and make a mess.
			</p>
		</div>
	);
}
